// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1591":"622319130055b2b4","3812":"782b3022afe43081","3973":"c947781a3282e08b"}[chunkId] + ".js";
};